<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
import CommentType from '@/constants/comments/CommentType'
import CommentDefault from './comment-default.vue'
import CommentDisputeHistoryOriginal from './comment-dispute-history-original.vue'
import CommentDisputeHistoryCandidate from './comment-dispute-history-candidate.vue'
import CommentDisputeHistoryClient from './comment-dispute-history-client.vue'
import CommentPayCalculatorSnapshot from './comment-pay-calculator-snapshot.vue'
import CommentDisputeHistoryCandidateTimeEntry from './comment-dispute-history-candidate-time-entry.vue'

export default {
  name: 'CommentControl',
  mixins: [baseMixin],
  props: {
    comment: {
      type: CommentModel,
      required: true,
    },
  },
  data: () => {
    return {}
  },
  computed: {
    commentControlDefinition() {
      switch (this.comment.type) {
        case CommentType.CustomDisputeResolutionHistoryOriginal:
          return this.commentControlFactory(CommentDisputeHistoryOriginal)
        case CommentType.CustomDisputeResolutionHistoryClient:
          return this.commentControlFactory(CommentDisputeHistoryClient)
        case CommentType.CustomDisputeResolutionHistoryCandidate:
          return this.commentControlFactory(CommentDisputeHistoryCandidate)
        case CommentType.CustomDisputeResolutionHistoryCandidateTimeEntry:
          return this.commentControlFactory(
            CommentDisputeHistoryCandidateTimeEntry
          )
        case CommentType.PayCalculatorSnapshotComment:
          return this.commentControlFactory(CommentPayCalculatorSnapshot)
        default:
          return this.commentControlFactory(CommentDefault)
      }
    },
  },
  methods: {
    commentControlFactory(component, extraProps = {}) {
      return {
        component,
        props: {
          ...extraProps,
          comment: this.comment,
        },
        events: {},
      }
    },
  },
}
</script>

<template>
  <component
    :is="commentControlDefinition.component"
    v-if="commentControlDefinition"
    data-testid="comment-control-component"
    :data-type="comment.type"
    v-bind="commentControlDefinition.props"
    v-on="commentControlDefinition.events"
  />
</template>
